import React, { useEffect, useState } from "react";
import { t } from "ttag";

import { Popover } from "../../../common/Popover";
import { RichText } from "../../../common/RichText";
import { useAppDispatch } from "../../reducers";
import { setOptionSelectionErrorState } from "../reducers";

interface IProps {
    optionSelectionErrorReason: string | undefined;
}

export const ConfiguratorOptionSelectionError = (
    props: IProps,
): React.ReactNode => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const dispatch = useAppDispatch();

    const onRequestClose = () => {
        dispatch(setOptionSelectionErrorState({ reason: "" }));
        setIsModalOpen(false);
    };

    const onOpen = () => {
        setIsModalOpen(true);
    };

    useEffect(() => {
        if (
            props.optionSelectionErrorReason &&
            props.optionSelectionErrorReason.length > 0 &&
            !isModalOpen
        ) {
            onOpen();
        }
        if (
            (!props.optionSelectionErrorReason ||
                props.optionSelectionErrorReason.length <= 0) &&
            isModalOpen
        ) {
            onRequestClose();
        }
    }, [props.optionSelectionErrorReason, isModalOpen]);

    return (
        <Popover
            triggerContent={""}
            triggerBtnProps={{
                className: "configurator-option-selection-error__holder",
            }}
            popperOptions={{
                modifiers: [
                    {
                        name: "offset",
                        options: {
                            offset: [0, 16],
                        },
                    },
                    {
                        name: "flip",
                        enabled: false,
                    },
                ],
                placement: "bottom",
            }}
            modalProps={{
                bodyOpenClassName:
                    "configurator-option-selection-error__body-open",
                overlayClassName:
                    "configurator-option-selection-error__overlay",
                className: "configurator-option-selection-error",
                // TODO(i18n): Use c() context for "Error" to disambiguate from other uses (e.g., "Error (modal label)" vs "Error (message)")
                contentLabel: t`Error`,
                style: {
                    overlay: {
                        backgroundColor: "transparent",
                    },
                },
            }}
            isOpen={isModalOpen}
            onRequestOpen={() => null}
            onRequestClose={onRequestClose}
            disableOpenButton={true}
        >
            <RichText
                html={
                    props.optionSelectionErrorReason
                        ? props.optionSelectionErrorReason
                        : ""
                }
                tagName="p"
            />
        </Popover>
    );
};
